import React, { useEffect, useState } from 'react';
import { faqApi } from '../services/api';

const DEFAULT_FALLBACK_FAQS = [
  // --- For Professionals ---
  {
    _id: '1',
    question: 'What is this platform about?',
    answer: 'It’s a marketplace and practice management tool for mental health practitioners. You can list your profile, receive bookings, manage sessions, issue invoices, write blogs and much more - all in one place.',
    category: 'For Professionals',
  },
  {
    _id: '2',
    question: 'Who can join the platform?',
    answer: 'Verified professionals working in Mental Health - Counselling Psychologist, Clinical Psychologist, Psychiatrists, Rehabilitation Psychologist, Neuropsychologist, Special Educator, Occupational Therapist, Speech Therapist, Sports Psychologist, Career Counsellors, Health Psychologist, Industrial Psychologist, Couples Counsellor, etc. Our focus is multidisciplinary, so families can find holistic mental health care in one place.',
    category: 'For Professionals',
  },
  {
    _id: '3',
    question: 'How is this different from other therapy platforms?',
    answer: 'Unlike commission-based platforms, you keep 100% of your earnings. You’ll get a place to be discovered, plus, you get built-in tools - session notes, product sale space, workshop listing space, invoicing, blogging space, automated whatsapp reminders, calendar sync and so much more that helps you manage your private practice like never before.',
    category: 'For Professionals',
  },
  {
    _id: '4',
    question: 'Is it free to join?',
    answer: 'Yes! You can join a Free profile listing to get discovered by users. And you can also upgrade to Pro to unlock advanced tools, more accessibility and management with enhanced presence.',
    category: 'For Professionals',
  },
  {
    _id: '5',
    question: 'How do I get verified?',
    answer: 'You’ll need to upload your credentials (Qualification Documents, PG Degree, RCI, NMC, or equivalent). Once approved, you’ll get a verified badge on your profile.',
    category: 'For Professionals',
  },
  {
    _id: '6',
    question: 'Do we take any commission on your sessions?',
    answer: 'No. We charge ₹29 per booking, as Convenience fee (paid by the client) to cover payment gateway and reminder costs, your consultation fee goes directly to you.',
    category: 'For Professionals',
  },
  {
    _id: '7',
    question: 'What tools do I get as a Pro provider?',
    answer: `You’ll unlock:
• Pro verified badge
• Google Calendar sync & availability slots
• Session notes templates
• Highlighted and Versatile Profile with more options to add on your profile
• Blogging Space
• Can create session bundles
• Automated reminders for upcoming sessions to you and the clients
• 1 Free Workshop listing
• 1 Free Profile ad promotion
• Additional Resources/ Material`,
    category: 'For Professionals',
  },
  {
    _id: '8',
    question: 'Can I host workshops or webinars?',
    answer: 'Yes! Pro users can post one free workshop listing per month (T&C applies), and all the other users can sponsor and post unlimited featured workshops. You can also charge attendees directly through our platform.',
    category: 'For Professionals',
  },
  {
    _id: '9',
    question: 'What does “Sponsored” mean?',
    answer: 'Professionals will have the option to Sponsor (run ads) to get top placement in search results and featured visibility on the homepage. This can be a daily or weekly ad-based plan for maximum exposure.',
    category: 'For Professionals',
  },

  // --- For Users / Clients ---
  {
    _id: '10',
    question: 'How do I find a professional?',
    answer: 'Use the search filters to browse by issue, services, age group, language, price, or location. You can view detailed profiles, introductions, and verified credentials.',
    category: 'For Users',
  },
  {
    _id: '11',
    question: 'What benefits do I get as a client on PsychMitra?',
    answer: `With PsychMitra, taking care of your mental health becomes simple, affordable, and empowering. Here’s how we make it better for you:
• No inflated fees – We don’t charge commissions from practitioners, so you get honest, transparent session prices.
• All experts, one platform – Connect with all kinds of verified psychologists, psychiatrists, therapists, and special educators, and more, all in one place.
• A safe space to express – Share your thoughts, post memes, and engage in open conversations on our dedicated community posting wall.
• Self-help tools that support you – Explore a wide range of resources to help you cope, reflect, and grow anytime you need.
• Smart session reminders – Get automatic notifications 24 hours and 1 hour before your session, so you never miss an appointment.
• Zero subscriptions or hidden costs – Pay only a minimal ₹29 convenience fee per booking, no extra charges.
• Learn and grow – Read insightful blogs from experts and attend workshops or seminars to deepen your understanding of mental health.
PsychMitra isn’t just a platform - it’s your personal mental wellness companion, designed to help you heal, learn, and thrive.`,
    category: 'For Users',
  },
  {
    _id: '12',
    question: 'How much does booking cost?',
    answer: 'Each session has the professional’s own fee + a small ₹29 Convenience fee for secure payments and automated reminders.',
    category: 'For Users',
  },
  {
    _id: '13',
    question: 'How do I book a session?',
    answer: 'Simply choose a time slot from the professional’s calendar, pay via UPI, Razorpay, or card, and get instant confirmation via WhatsApp/email.',
    category: 'For Users',
  },
  {
    _id: '14',
    question: 'Do I get reminders?',
    answer: 'Yes, you’ll receive WhatsApp reminders 24 hours and 1 hour before your session, so you never miss an appointment.',
    category: 'For Users',
  },
  {
    _id: '15',
    question: 'Can I book multiple sessions?',
    answer: 'Absolutely. You can purchase session bundles at once for easier scheduling and better continuity.',
    category: 'For Users',
  },
  {
    _id: '16',
    question: 'Can I leave a review after my session?',
    answer: 'Yes! After your session, you’ll get a link to leave a review and easily rebook the same professional.',
    category: 'For Users',
  },

  // --- General Questions ---
  {
    _id: '17',
    question: 'How do professionals get paid?',
    answer: 'The full payment amount will be deposited to the mental health practitioner’s linked account. The platform doesn’t hold or deduct commissions (only the ₹29 Convenience fee applies to users).',
    category: 'General',
  },
  {
    _id: '18',
    question: 'Is my data secure?',
    answer: 'Yes, all data is encrypted and stored securely.',
    category: 'General',
  },
  {
    _id: '19',
    question: 'I’m a new practitioner, is this worth it for me?',
    answer: 'Definitely! Build your online presence & get visibility by listing on PsychMitra. You’ll get tools, trust-building features, practice management features, and much more that can help you grow faster.',
    category: 'General',
  },
  {
    _id: '20',
    question: 'I’m already an established practitioner, how does it help me?',
    answer: 'PsychMitra helps you amplify your presence in a dedicated Ecosystem built for Mental Health Practitioners. Showcase your expertise, attract more clients, build meaningful connections, and unlock new growth opportunities - all in one trusted space designed to help you thrive.',
    category: 'General',
  },
];

function FAQPage() {
  const [faqs, setFaqs] = useState(DEFAULT_FALLBACK_FAQS);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [activeAccordion, setActiveAccordion] = useState(0);

  useEffect(() => {
    const loadFaqs = async () => {
      try {
        const res = await faqApi.getPublicFaqs();
        if (res?.success && res.faqs && res.faqs.length > 0) {
          setFaqs(res.faqs);
          if (res.categories && res.categories.length > 0) {
            setCategories(res.categories);
          }
        }
      } catch (err) {
        console.warn('Could not load live FAQs from server, using default set.', err);
      }
    };
    loadFaqs();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  const filteredFaqs =
    selectedCategory === 'all'
      ? faqs
      : faqs.filter((item) => item.category === selectedCategory);

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? -1 : id);
  };

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-4-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Frequently Asked Questions</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>FAQ</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* FAQ Section Start */}
      <section className="faq-section" style={{
        background: 'linear-gradient(120deg, #f8fafc 0%, #e0e7ff 100%)',
        padding: '64px 0 80px 0',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0 d-flex justify-content-center">
              <img
                src="/assets/images/new_img/Firefly_Gemini Flash_-A serene, minimalist illustration of a gentle penguin meditating on _an ice floe ove 359813.png"
                alt="FAQ Illustration"
                style={{ maxWidth: '340px', width: '100%', borderRadius: '18px', boxShadow: '0 4px 32px rgba(80,80,120,0.10)' }}
              />
            </div>
            <div className="col-lg-6 text-center text-lg-start">
              <div className="section-title wow fadeInUp">
                <span className="section-title__tagline" style={{ color: '#7c3aed', fontWeight: 600, fontSize: '1.1rem', letterSpacing: '0.04em' }}>Have Questions?</span>
                <h2 className="section-title__title" style={{ fontSize: '2.5rem', fontWeight: 800, color: '#2d2d4d', marginBottom: '18px' }}>Frequently Asked Questions</h2>
                <p style={{ color: '#555', fontSize: '1.13rem', maxWidth: '420px', margin: '0 auto 0 0' }}>
                  Find answers to common questions about our services, appointments, confidentiality, and more.
                </p>
              </div>
            </div>
          </div>
          {categories.length > 0 && (
            <div className="row justify-content-center mb-4">
              <div className="col-lg-10 d-flex flex-wrap justify-content-center gap-2">
                <button
                  onClick={() => setSelectedCategory('all')}
                  style={{
                    padding: '8px 18px',
                    borderRadius: '20px',
                    border: 'none',
                    background: selectedCategory === 'all' ? '#7c3aed' : '#ffffff',
                    color: selectedCategory === 'all' ? '#ffffff' : '#475569',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    transition: 'all 0.2s',
                  }}
                >
                  All Categories
                </button>
                {categories.map((cat, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedCategory(cat)}
                    style={{
                      padding: '8px 18px',
                      borderRadius: '20px',
                      border: 'none',
                      background: selectedCategory === cat ? '#7c3aed' : '#ffffff',
                      color: selectedCategory === cat ? '#ffffff' : '#475569',
                      fontWeight: 600,
                      fontSize: '14px',
                      cursor: 'pointer',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      transition: 'all 0.2s',
                    }}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="faq-accordion" style={{ maxWidth: '700px', margin: '0 auto' }}>
                {filteredFaqs.map((item, index) => {
                  const itemId = item._id || item.id || index;
                  const isCurrentActive = activeAccordion === itemId || (activeAccordion === 0 && index === 0);

                  return (
                    <div
                      key={itemId}
                      className="faq-item wow fadeInUp"
                      style={{
                        background: 'rgba(255,255,255,0.85)',
                        borderRadius: '16px',
                        boxShadow: '0 2px 16px rgba(80,80,120,0.08)',
                        marginBottom: '18px',
                        border: isCurrentActive ? '2px solid #7c3aed' : '2px solid #f3f3fa',
                        transition: 'border 0.2s, box-shadow 0.2s',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        className={`faq-title ${isCurrentActive ? 'active' : ''}`}
                        onClick={() => toggleAccordion(itemId)}
                        style={{
                          cursor: 'pointer',
                          padding: '22px 28px',
                          fontWeight: 700,
                          fontSize: '1.13rem',
                          color: isCurrentActive ? '#7c3aed' : '#2d2d4d',
                          background: isCurrentActive ? 'rgba(124,58,237,0.07)' : 'transparent',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderBottom: isCurrentActive ? '1px solid #e0e7ff' : '1px solid #f3f3fa',
                          transition: 'background 0.2s, color 0.2s',
                        }}
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') toggleAccordion(itemId);
                        }}
                      >
                        <span>{item.question}</span>
                        <span
                          className="plus-icon"
                          style={{
                            fontSize: '1.7rem',
                            fontWeight: 400,
                            color: '#7c3aed',
                            marginLeft: '18px',
                            transition: 'transform 0.2s',
                            transform: isCurrentActive ? 'rotate(90deg)' : 'none',
                          }}
                        >
                          {isCurrentActive ? '-' : '+'}
                        </span>
                      </div>
                      <div
                        className="faq-content"
                        style={{
                          maxHeight: isCurrentActive ? '400px' : '0',
                          opacity: isCurrentActive ? 1 : 0,
                          padding: isCurrentActive ? '18px 28px 22px 28px' : '0 28px',
                          color: '#444',
                          fontSize: '1.05rem',
                          background: 'rgba(255,255,255,0.97)',
                          transition: 'all 0.35s cubic-bezier(.4,2,.6,1)',
                          overflow: 'hidden',
                        }}
                        aria-hidden={!isCurrentActive}
                      >
                        <p style={{ margin: 0 }}>{item.answer}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Call to Action */}
              <div className="faq-cta-card wow fadeInUp" style={{
                background: '#f5f6fa',
                borderRadius: '16px',
                boxShadow: '0 2px 16px rgba(124,58,237,0.10)',
                padding: '36px 32px',
                margin: '40px auto 0 auto',
                maxWidth: '600px',
                textAlign: 'center',
                color: '#2d2d4d',
              }}>
                <h3 style={{ fontWeight: 800, fontSize: '1.5rem', marginBottom: '10px' }}>Didn’t find your answer?</h3>
                <p style={{ fontSize: '1.08rem', marginBottom: '18px' }}>We’re here to help! Reach out to our team for personalized support or to book a session.</p>
                <a href="/contact" className="thm-btn" style={{ background: '#fff', color: '#7c3aed', fontWeight: 700, borderRadius: '8px', padding: '12px 32px', fontSize: '1.08rem', boxShadow: '0 2px 8px rgba(124,58,237,0.08)' }}>
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section End */}
    </>
  );
}

export default FAQPage;
